import React from 'react';
import _ from 'lodash';
import { Checkbox, InputGroup, InputMask } from '~/components/form';
import { onlyNumbers, isValidCnpj } from '~/helper';
import { MASK_CNPJ, MASK_PHONE } from '~constants'
import { ContentContainer } from '~/views/companies/styles';

export const TabGeneral = ({ errors, permissions, status, touched, values, previewMode, setFieldTouched, onSearchCnpj }) => {
  return (
    <ContentContainer>
      <Checkbox name='active' label='Ativa' />

      <Checkbox name='fromGroup' label='Empresa do Grupo Palmeiras?' />

      { (!values.source || values.source === 'national') ?
        <InputMask
          disabled={previewMode}
          mask={MASK_CNPJ}
          name="identify"
          label={'CNPJ'}
          hasError={errors.identify && touched.identify}
          onBlur={(e) => {
            const value = onlyNumbers(e.target.value) || '';
            setFieldTouched('identify', true);
            if (isValidCnpj(value) && onSearchCnpj && !values.name && !values.tradeName) {
              onSearchCnpj(value, values);
            }
          }}
          />
        :
        <InputGroup
          type="text"
          maxLength={20}
          disabled={previewMode}
          name="identify"
          label={'Número de Registro'}
          required={true}
          hasError={errors.identify && touched.identify} />
      }

      <InputGroup
        type="text"
        name="name"
        maxLength={100}
        label="Razão social"
        disabled={previewMode}
        hasError={errors.name && touched.name} />
      
      <InputGroup
        type="text"
        name="tradeName"
        label="Nome fantasia"
        maxLength={100}
        disabled={previewMode}
        hasError={errors.tradeName && touched.tradeName} />

      <InputGroup
        type="email"
        name="email"
        label="Email"
        maxLength={100}
        disabled={previewMode}
        hasError={errors.email && touched.email} />

      <InputGroup
        type="text"
        name="user.name"
        maxLength={100}
        label="Nome do responsável"
        disabled={previewMode}
        hasError={_.get(errors, 'user.name') && _.get(touched, 'user.name')} />

      <InputMask
        name="phone"
        label="Telefone"
        mask={MASK_PHONE}
        disabled={previewMode}
        value={values.phone}
        hasError={errors.phone && touched.phone} />
      
    </ContentContainer>
  );
};
